import { render, staticRenderFns } from "./TaskGroups.vue?vue&type=template&id=11357512&"
import script from "./TaskGroups.vue?vue&type=script&lang=js&"
export * from "./TaskGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports